<template>
  <!--<? if ($upper_banner->category->is_active): ?>-->
  <div class=".col-6 col-sm-12 col-md-6">
    <div class="single-banner zoom">
      <span v-if="product.old_price" class="sticker-new rubik"
      >- {{ discount }} %</span
      >
      <span
        style="
          position: absolute;
          top: 50px;
          left: 20px;
          color: #fff;
          font-size: 20px;
          text-shadow: 1px 1px 2px black, 0 0 1em darkorange;
        "
      >{{ product.title }}</span
      >

      <router-link
        @click.prevent="$scrollToTop"
        :to="{
          name: 'ProductDetail',
          params: { alias: product.alias },
        }"
      >
        <span class="img-wrapper">
          <img :data-src="`../../../../img/products/${product.alias}/upper-banner-${product.id}.jpg`"
               :src="require(`/src/assets/img/loading.gif`)"
               :alt="product.alias"
               class="img-thumbnail"
          />
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      loading: false,
      discount: null,
      ratingYes: null,
      ratingNo: null
    };
  },

  components: {},

  computed() {
  },

  mounted() {
    this.discount = parseInt(
      (this.product.old_price / this.product.price) * 100 - 100
    );
    this.ratingYes = this.product.rating;
    this.ratingNo = 5 - this.ratingYes;
  }
};
</script>

<style scoped>
.img-wrapper img {
  max-width: 540px;
  max-height: 420px;
  min-width: 540px;
  min-height: 420px;
  object-fit: cover;
}

@media (max-width: 1200px) {
  .img-wrapper {
    display: flex;
    justify-content: center;
  }

  .img-wrapper img {
    max-width: 420px;
    max-height: 420px;
    min-width: 420px;
    min-height: 420px;
    object-fit: cover;
  }
}

@media (max-width: 992px) {
  .img-wrapper img {
    max-width: 330px;
    max-height: 257px;
    min-width: 330px;
    min-height: 257px;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    .img-wrapper {
      margin-bottom: 10px;
    }

    .img-wrapper img {
      min-width: 490px;
      object-fit: cover;
    }
  }

  @media (max-width: 576px) {
    .img-wrapper img {
      max-width: 576px;
      max-height: 257px;
      /*min-width: 576px;*/
      min-height: 257px;
      object-fit: cover;
    }
  }
}
</style>
